import styled from "styled-components";

export const NotiViewContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
`;

export const NotiViewHeader = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  background: white;
  border-bottom: 1px solid #E5E5E5;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 480px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

export const NotiViewBack = styled.button`
  position: absolute;
  left: 20px;
  border: none;
  background: none;
  padding: 8px;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
`;

export const NotiViewTitle = styled.div`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;

export const NotiViewBoard = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: calc(100vh - 130px);
  margin: 80px 10px 0 10px;
`;

export const NotiTitle = styled.div`
  display: flex;
  justify-content: center;
  font-size: 17px;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const NotiDate = styled.div`
  display: flex;
  justify-content: end;
  font-size: 13px;
  color: #A1A1A1;
  margin-right: 10px;
  margin-bottom: 10px;
`;

export const NotiContent = styled.div`
  border-top: 1.6px solid #D4D4D4;
  padding-top: 7px;
  overflow-y: auto;
`;

export const NotiList = styled.div`
  position: fixed;
  right: 15px;
  bottom: 15px;
  padding: 8px 25px;
  text-align: center;
  color: white;
  font-size: 15px;
  font-weight: bold;
  background-color: #055A23;
  text-decoration: none;
  cursor: pointer;
`;
